import { compose, withHandlers, withPropsOnChange } from 'recompose';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { confirmBarber, deleteBarber, redirectToBarberList } from './actions';
import UnconfirmedBarbersList from './components/UnconfirmedBarbersList';
import { getAllUnconfirmed } from './selector';
import confirmModal from '../../common/confirmModal';

const mapStateToProps = state => ({
  barbers: getAllUnconfirmed(state),
  shop: state.auth.shop,
});

const mapDispatchToProps = { deleteBarber, confirmBarber, redirectToBarberList };

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onConfirm: props => async (e, barberId) => {
      e.preventDefault();

      const confirmed = await confirmModal({
        type: 'danger',
        title: 'Confirm barber',
        message: 'Are you sure you want to confirm this barber?',
      });

      if (!confirmed) {
        return false;
      }
      return props.confirmBarber(props.shop, barberId);
    },
    onDelete: props => async (e, barberId) => {
      e.preventDefault();

      const confirmed = await confirmModal({
        type: 'danger',
        title: 'Delete barber',
        message: 'Are you sure you want to delete this barber?',
      });

      if (!confirmed) {
        return false;
      }

      return props.deleteBarber(props.shop, barberId);
    },
  }),
  withPropsOnChange(
    ['barbers'],
    (props) => {
      if (isEmpty(props.barbers)) props.redirectToBarberList();
    }
  )
)(UnconfirmedBarbersList);
